import { DeepPartial, FieldValues, UseFormWatch } from 'react-hook-form';
import { useMount } from 'src/helpers/hooks/useMount';

/**
 * Custom hook that watches for changes in form fields and invokes a callback function.
 *
 * @template T - The type of form field values.
 * @param {UseFormWatch<T>} watch - The useFormWatch function from react-hook-form library.
 * @param {(data: DeepPartial<T>) => void} watchCallback - The callback function to be invoked when form field values change.
 */
export const useFormWatcher = <T extends FieldValues>(
  watch: UseFormWatch<T>,
  watchCallback: (data: DeepPartial<T>) => void,
) => {
  useMount(() => {
    const { unsubscribe } = watch((data) => watchCallback(data));

    return () => {
      unsubscribe();
    };
  });
};
